const OTP_VALID_LENGTH = 6;

const hasAlphabeticalCharacters = (otp) => {
  return /[a-zA-Z]/.test(otp);
};

const hasValidLength = (otp) => {
  return otp.length === OTP_VALID_LENGTH;
};

export const checkOtpValid = (otp) => {
  return !hasAlphabeticalCharacters(otp) && hasValidLength(otp);
};
